import React, { useState } from "react";
import { X, GitCompare, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const ROWS = [
  { label: "Prix / jour", render: (v) => `${v.price_per_day} MAD` },
  { label: "Caution", render: (v) => `${v.deposit?.toLocaleString()} MAD` },
  { label: "Catégorie", render: (v) => v.category },
  { label: "Kilométrage", render: (v) => v.mileage_policy },
  { label: "Boîte", render: (v) => v.transmission },
  { label: "Carburant", render: (v) => v.fuel },
  { label: "Places", render: (v) => v.seats },
  { label: "Climatisation", render: (v) => (v.air_conditioning ? "Oui" : "Non") },
  { label: "Loueur", render: (v) => (v.agency ? `Vérifié · ${v.agency.city}` : "—") },
  { label: "Ville", render: (v) => v.city },
];

export default function Compare() {
  const { compare, toggleCompare, clearCompare } = useAuth();
  const navigate = useNavigate();

  return (
    <PublicLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 flex items-center gap-3">
              <GitCompare className="h-8 w-8" style={{ color: "#006233" }} /> Comparer
            </h1>
            <p className="mt-2 text-slate-500">Jusqu'à 3 véhicules côte à côte.</p>
          </div>
          {compare.length > 0 && (
            <Button variant="outline" onClick={clearCompare} data-testid="compare-clear-btn">Tout retirer</Button>
          )}
        </div>

        {compare.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-slate-300 py-24 text-center">
            <GitCompare className="h-12 w-12 mx-auto text-slate-300" />
            <p className="mt-4 text-slate-500">Aucun véhicule sélectionné pour la comparaison.</p>
            <Button className="mt-6 text-white" style={{ background: "#006233" }} onClick={() => navigate("/cars")} data-testid="compare-browse-btn">
              Explorer les véhicules <ArrowRight className="h-4 w-4 ml-1.5" />
            </Button>
          </div>
        ) : (
          <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr>
                  <th className="p-4 text-left w-40" />
                  {compare.map((v) => (
                    <th key={v.id} className="p-4 text-left align-top">
                      <div className="relative">
                        <button onClick={() => toggleCompare(v)} className="absolute -top-2 -right-2 rounded-full bg-slate-900 p-1 text-white" data-testid={`compare-remove-${v.id}`}>
                          <X className="h-3.5 w-3.5" />
                        </button>
                        <img src={v.image_url} alt={v.model} className="h-24 w-full object-cover rounded-lg" />
                        <p className="mt-2 font-bold text-slate-900 text-sm">{v.brand} {v.model}</p>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((row, i) => (
                  <tr key={row.label} className={i % 2 ? "bg-slate-50" : ""}>
                    <td className="p-4 text-sm font-semibold text-slate-500">{row.label}</td>
                    {compare.map((v) => (
                      <td key={v.id} className="p-4 text-sm text-slate-900 font-medium">{row.render(v)}</td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td className="p-4" />
                  {compare.map((v) => (
                    <td key={v.id} className="p-4">
                      <Button size="sm" className="w-full text-white" style={{ background: "#006233" }} onClick={() => navigate(`/car/${v.id}`)} data-testid={`compare-view-${v.id}`}>
                        Voir & réserver
                      </Button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
